import { screenSmMin, screenXlMin, screenXsMax, spacer24, spacer32 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { sidebarBaseWidth } from "../../styles";
var calcMaxWidth = "".concat(parseInt(screenXlMin, 10) - parseInt(sidebarBaseWidth, 10), "px");
export var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-1n5ckz4-0"
})(["display:flex;flex-direction:column;flex:1;@media (max-width:", "){padding-inline-start:", ";padding-inline-end:", ";}@media (min-width:", "){padding-inline-start:", ";padding-inline-end:", ";margin-inline-start:", ";max-inline-size:", ";}"], screenXsMax, spacer24, spacer24, screenSmMin, spacer32, spacer32, function (props) {
  return props.sidebarWidth || sidebarBaseWidth;
}, function (props) {
  return props.contentMaxWidth || calcMaxWidth;
});
export default Content;